import { render } from "./BaseHorizontalBarChart.vue?vue&type=template&id=6ee8e28c"
import script from "./BaseHorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./BaseHorizontalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/BaseHorizontalBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ee8e28c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ee8e28c', __exports__)) {
    console.log('reload')
    api.reload('6ee8e28c', __exports__)
  }
  
  module.hot.accept("./BaseHorizontalBarChart.vue?vue&type=template&id=6ee8e28c", () => {
    console.log('re-render')
    api.rerender('6ee8e28c', render)
  })

}


export default __exports__